import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Card, Button, ListGroup } from 'react-bootstrap';
import PageTitle from '../../common/PageTitle';
import { google } from '../../../assets/Assets';
import { useUser } from '../../../context/UserContext';
import { uSubscriptionName, uSubscriptionExpiration, uSearchesRemaining } from '../../../utils';

const Home = () => {

  const { user } = useUser();
  const navigate = useNavigate();
  const [userPlanDeadline, setUserPlanDeadline] = useState('-');
  const [userPlanName, setUserPlanName] = useState('-');
  const [userSearchesRemaining, setUserSearchesRemaining] = useState(null);


  useEffect(() => {
    if (user) {
      setUserPlanName(uSubscriptionName(user.subscription));
      setUserPlanDeadline(uSubscriptionExpiration(user.releasedDeadline));
      setUserSearchesRemaining(uSearchesRemaining(user.searches));
    }
  }, [user]);

  const handleContract = () => {
    navigate('/main/plans');
  };

  return (
    <>
      <Container>
        <Row>
          <Col>
            <PageTitle text='Bem-vindo!' />
          </Col>
        </Row>
      </Container>
      <Container className="">
        <Row>
          {/* Seções da esquerda */}
          <Col md={8}>
            <Row className="mb-3">
              <Col>
                <Card>
                  <Card.Header className="bg-secondary text-white">PESQUISAR</Card.Header>
                  <Card.Body>
                    <Card.Text>
                      É muito fácil consultar e achar exatamente o que você precisa. Seja um insumo ou uma composição, o CPUWEB facilita suas atividades para compor seus projetos e orçamentos.
                    </Card.Text>
                    <Button variant="primary" href="main/search">Comece Agora</Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Row>
              <Col>
                <Card>
                  <Card.Header className="bg-secondary text-white">BASES DE DADOS</Card.Header>
                  <Card.Body>
                    <Card.Text>
                      Aqui você tem acesso aos dados de todas as nossas bases: quantidade de itens, últimas atualizações, grupos de custos e muito mais.
                    </Card.Text>
                    <Card.Text>
                      Você pode ainda exportar todos os conteúdos para planilhas e trabalhar os dados de outras formas.
                    </Card.Text>
                    <Button variant="primary" href="main/bases">Conheça os Dados!</Button>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Col>

          {/* Seção da direita */}
          <Col md={4}>
            {user && user.subscription === 0 && (
              <Card className="mb-3">
                <Card.Header className="text-white bg-secondary">
                  ASSINATURA
                </Card.Header>
                <Card.Body>
                  <Row>
                    <Col xs={4} className="flex-item">Nome:</Col>
                    <Col xs={8} className="flex-item">{user.name}</Col>
                  </Row>
                  <Row>
                    <Col xs={4} className="flex-item">E-mail:</Col>
                    <Col xs={8} className="flex-item">{user.email}</Col>
                  </Row>
                  <Row>
                    <Col xs={4} className="flex-item">Plano:</Col>
                    <Col xs={8} className="flex-item">{userPlanName}</Col>
                  </Row>
                  <Row>
                    <Col xs={4} className="flex-item">Vencimento:</Col>
                    <Col xs={8} className="flex-item">{userPlanDeadline}</Col>
                  </Row>
                  <Row>
                    <Col xs={4} className="flex-item">Pesquisas:</Col>
                    <Col xs={8} className="flex-item">{userSearchesRemaining} de 5</Col>
                  </Row>
                  {userPlanDeadline && userPlanDeadline !== 'Vitalício' &&
                    <Row className="justify-content-center mt-3">
                      <Col md="auto"><Button variant="success" onClick={handleContract} >CONTRATAR</Button></Col>
                    </Row>
                  }
                </Card.Body>
              </Card>
            )}

            {/* Boas-vindas */}
            <Card className="mb-3">
              <Card.Body>
                <p>
                  Explore o novo conceito em orçamentos para a construção civil na WEB.
                </p>
                <ListGroup variant="flush">
                  <ListGroup.Item>Preços de referência para insumos e serviços</ListGroup.Item>
                  <ListGroup.Item>Serviços de órgãos públicos</ListGroup.Item>
                  <ListGroup.Item>Bases Atualizadas</ListGroup.Item>
                  <ListGroup.Item>Relatórios Gráficos</ListGroup.Item>
                  <ListGroup.Item>Exportação dados em Excel</ListGroup.Item>
                  <ListGroup.Item>Banco de serviços base</ListGroup.Item>
                  <ListGroup.Item>
                    App para pesquisas onde estiver
                    <img
                      src={google}
                      alt="Google Play"
                      className="ms-2"
                      style={{ width: '100px' }}
                    />
                  </ListGroup.Item>
                </ListGroup>
              </Card.Body>
            </Card>

            {/* LGPD */}
            <Card>
              <Card.Header className="bg-secondary text-white">LGPD</Card.Header>
              <Card.Body>
                {user.lgpd ?
                  (
                    <>
                      <p>
                        Você já aceitou nossos termos de proteção aos dados (LGPD).
                      </p>
                    </>
                  )
                  :
                  (
                    <>
                      <p>
                        Aceite nossos termos de proteção aos dados (LGPD) e garanta a segurança de suas informações.
                      </p><p>
                        <Button variant="primary" href="main/my-profile">MEU PERFIL</Button>
                      </p></>
                  )
                }
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Home;